import http from "../http-common";

class processLogService {
  getAll() {
    return http.get("/processlog");
  }

  get(id) {
    return http.get(`/processlog/${id}`);
  }

  getByBatch(id) {
    return http.get(`/processlog/byBatch/${id}`);
  }
}

export default new processLogService();
